export default "__VITE_ASSET__7413fae5__"